/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationCrossPlayHandlersQuestEventDto
 */
export interface FxIdApplicationCrossPlayHandlersQuestEventDto {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationCrossPlayHandlersQuestEventDto
     */
    Code: string;
}

/**
 * Check if a given object implements the FxIdApplicationCrossPlayHandlersQuestEventDto interface.
 */
export function instanceOfFxIdApplicationCrossPlayHandlersQuestEventDto(value: object): value is FxIdApplicationCrossPlayHandlersQuestEventDto {
    if (!('Code' in value) || value['Code'] === undefined) return false;
    return true;
}

export function FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSON(json: any): FxIdApplicationCrossPlayHandlersQuestEventDto {
    return FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationCrossPlayHandlersQuestEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'Code': json['Code'],
    };
}

export function FxIdApplicationCrossPlayHandlersQuestEventDtoToJSON(json: any): FxIdApplicationCrossPlayHandlersQuestEventDto {
    return FxIdApplicationCrossPlayHandlersQuestEventDtoToJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersQuestEventDtoToJSONTyped(value?: FxIdApplicationCrossPlayHandlersQuestEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Code': value['Code'],
    };
}

